module.exports = __webpack_public_path__ + "static/media/asterisk.8d5bdccd.svg";